const banksValues = [
  { value: "ABNASGSG", label: "ABN AMRO BANK" },
  { value: "ANTPSGSG", label: "ANEXT BANK PTE LTD MAIN BRANCH" },
  { value: "ANZBSGSX", label: "ANZ BANK (FORMERLY ABN, RBS)" },
  { value: "BKKBSGSG", label: "BANGKOK BANK PUBLIC CO LTD" },
  { value: "BOFASG2X", label: "BANK OF AMERICA NT & SA" },
  { value: "BKCHSGSG", label: "BANK OF CHINA" },
  { value: "BEASSGSG", label: "BANK OF EAST ASIA LTD" },
  { value: "BKIDSGSG", label: "BANK OF INDIA" },
  { value: "BNPASGSG", label: "BANQUE NATIONALE DE PARIS" },
  { value: "CTCBSGSG", label: "CHINATRUST COMMERCIAL BANK CO." },
  { value: "CIBBSGSG", label: "CIMB BANK BERHAD" },
  { value: "CITISGSG", label: "CITIBANK N AX (7214)" },
  { value: "CITISGSL", label: "CITIBANK SINGAPORE LIMITED (9201)" },
  { value: "COBASGSX", label: "COMMERZBANK AKTIENGESELLSCHAFT" },
  { value: "CRLYSGSG", label: "CREDIT AGRICOLE CORPORATE AND" },
  { value: "CTBC BANK", label: "CTBC BANK CO. LTD" },
  { value: "DEUTSGSG", label: "DEUTSCHE BANK AG" },
  { value: "DBSSSGSG", label: "DEVELOPMENT BANK OF S'PORE LTD" },
  { value: "DNBASGSG", label: "DNB BANK ASA" },
  { value: "FCBKSGSG", label: "FIRST COMMERCIAL BANK" },
  { value: "POSBSGSG", label: "FOR POSB ACCOUNT ONLY" },
  { value: "HLBBSGSG", label: "H L BANK" },
  { value: "HSBCSGSG", label: "HONGKONG & SHANGHAI BANKING (7232)" },
  { value: "HSBCSGS2", label: "HSBC BANK (SINGAPORE) LTD (9548)" },
  { value: "ICICSGSG", label: "ICICI BANK LIMITED" },
  { value: "IDIBSGSG", label: "INDIAN BANK" },
  { value: "IOBASGSG", label: "INDIAN OVERSEAS BANK" },
  { value: "ICBKSGSG", label: "INDUSTRIAL & COMMERCIAL BANK" },
  { value: "BCITSGSG", label: "INTESA SANPAOLO SPA" },
  { value: "CHASSGSG", label: "JPMORGAN CHASE BANK, N.A." },
  { value: "KOEXSGSG", label: "KOREA EXCHANGE BANK" },
  { value: "MBBESGSG", label: "MALAYAN BANKING BERHAD (9636)" },
  { value: "MARIBANK", label: "MARIBANK SINGAPORE PTE LTD" },
  { value: "MBBESGS2", label: "MAYBANK SINGAPORE LIMITED (7302)" },
  { value: "MHCBSGSG", label: "MIZUHO BANK LIMITED" },
  { value: "BOTKSGSX", label: "MUFG BANK LTD" },
  { value: "NATASGSG", label: "NATIONAL AUSTRALIA BANK LTD" },
  { value: "NDEASGSG", label: "NORDEA BANK AB" },
  { value: "OCBCSGSG", label: "OVERSEA-CHINESE BANKING CORP" },
  { value: "BNINSGSG", label: "PT BANK NEGARA INDONESIA" },
  { value: "QNBASGSG", label: "QATAR NATIONAL BANK SAQ" },
  { value: "RHBBSGSG", label: "RHB BANK BERHAD" },
  { value: "ROYC", label: "ROYAL BANK OF CANADA SINGAPORE BRANCH" },
  { value: "ESSESGSG", label: "SKANDINAVISKA ENSKILDA BANKEN" },
  { value: "SOGESGSG", label: "SOCIETE GENERALE" },
  { value: "SCBLSGSG", label: "STANDARD CHARTERED BANK (7144)" },
  { value: "SCBLSG22", label: "STANDARD CHARTERED BANK(S) LTD (9496)" },
  { value: "SBINSGSG", label: "STATE BANK OF INDIA" },
  { value: "SMBCSGSG", label: "SUMITOMO MITSUI BANKING CO" },
  { value: "HANDSGSG", label: "SVENSKA HANDELSBANKEN AB" },
  { value: "SCSB", label: "THE SHANGHAI COMMERCIAL AND SASCSB" },
  { value: "TRBUSGSG", label: "TRUST BANK SINGAPORE LTD" },
  { value: "UBSWSGSG", label: "UBS AG" },
  { value: "UCBASGSG", label: "UCO BANK" },
  { value: "BVBESGSG", label: "UNICREDIT BANK AG" },
  { value: "UOVBSGSG", label: "UNITED OVERSEAS BANK LTD" },
  { value: "WISE ASIA", label: "WISE ASIA-PACIFIC PTE LTD" },
  { value: "OTH", label: "Others" }
];

export default banksValues;